import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesParcelCreateMain } from './modules/ui/Main';

const ParcelCreatePage = (
  <SuspensePage>
    <PagesParcelCreateMain />
  </SuspensePage>
);

export default ParcelCreatePage;
